// import { getPrasedToken } from "./utils"
import { setNotification } from "@/api/notification"
// export const isRTALogin = () => {
//   const token = getPrasedToken()
//   if (!token) return false
//   if (token.logChannel === 1 || token.logChannel === 2) {
//     return true
//   }
//   return false
// }

const PasswordRegex = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/

export const validatePassword = password => {
  return PasswordRegex.test(password)
}

export const validatePhoneNumber = phoneNumber => {
  const regexChinaMainland = /^(\+86|86)?\s?1[3-9]\d{9}$/
  // reference to yuu
  const regexHongKong = /^(\+852|852)?\s?[4-9]\d{7}$/
  const regexMacau = /^(\+853|853)?\s?6\d{7}$/
  return regexChinaMainland.test(phoneNumber) || regexHongKong.test(phoneNumber) || regexMacau.test(phoneNumber)
}

export async function closeAPPAndSMSNotification(phoneNum) {
  const params = {
    edit: 2,
    phoneNum
  }

  const NEED_OPEN_TYPE = [2, 5]
  const primises = NEED_OPEN_TYPE.map(type => {
    return setNotification({ params: { ...params, blacklistType: type } })
  })
  await Promise.all(primises)
}
